/* labosch-patches-post-mobile-v95.js — V95 consolidated. */

/* ==== labosch-v85-final.js ==== */
(function(){
  'use strict';
  function syncFooter(){
    var mobile=window.matchMedia && window.matchMedia('(max-width:900px)').matches;
    document.querySelectorAll('[data-lbx85-footer-group]').forEach(function(group){
      if(group.dataset.lbx85Touched==='1' && mobile) return;
      if(mobile){ group.removeAttribute('open'); }
      else { group.setAttribute('open',''); }
    });
  }
  function init(){
    document.querySelectorAll('[data-lbx85-footer-group] summary').forEach(function(summary){
      if(summary.dataset.lbx85Bound==='1') return;
      summary.dataset.lbx85Bound='1';
      summary.addEventListener('click',function(){
        var group=summary.closest('[data-lbx85-footer-group]');
        if(group && window.matchMedia('(max-width:900px)').matches) group.dataset.lbx85Touched='1';
      });
    });
    syncFooter();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  window.addEventListener('resize',function(){clearTimeout(window.__lbx85FooterTimer);window.__lbx85FooterTimer=setTimeout(syncFooter,120);},{passive:true});
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v86-final.js ==== */
(function(){
  'use strict';
  function init(){
    /* Hidden story dialogs must never keep focusable descendants exposed. */
    document.querySelectorAll('[data-lbx-story-modal]').forEach(function(modal){
      if(modal.hidden || modal.getAttribute('aria-hidden')==='true') modal.setAttribute('inert','');
      else modal.removeAttribute('inert');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v87-final.js ==== */
(function(){
  'use strict';

  function q(root,sel){return (root||document).querySelector(sel);}
  function text(el){return el ? String(el.textContent||'').replace(/\s+/g,' ').trim() : '';}

  function retireLegacySticky(){
    document.querySelectorAll('.lbx78-sticky-buy').forEach(function(el){el.remove();});
    document.body.classList.remove('lbx78-sticky-active');
  }

  function initSticky(){
    document.querySelectorAll('[data-lbx87-sticky-atc]').forEach(function(sticky){
      if(sticky.dataset.lbx87Ready==='1')return;
      sticky.dataset.lbx87Ready='1';
      var sectionId=sticky.getAttribute('data-lbx87-section');
      var root=document.getElementById('lbx-product-'+sectionId) || q(document,'.lbx-product-pro');
      if(!root)return;
      var buy=q(root,'[data-lbx-buy-button]');
      var purchase=buy && buy.closest('.lbx-purchase-actions');
      var preorder=q(root,'[data-lbx-preorder-open]');
      var image=q(sticky,'[data-lbx87-sticky-image]');
      var title=q(sticky,'[data-lbx87-sticky-title]');
      var price=q(sticky,'[data-lbx87-sticky-price]');
      var compare=q(sticky,'[data-lbx87-sticky-compare]');
      var prices=sticky.querySelector('.lbx87-sticky-atc__prices');
      var action=q(sticky,'[data-lbx87-sticky-buy]');
      var footer=q(document,'[data-lbx85-footer]');
      var raf=0;
      var minimumScroll=Math.min(260,Math.max(150,Math.round((window.innerHeight||700)*0.22)));

      function reserveMode(){
        /* V107: el sticky debe pasar a Reserva en cuanto la variante seleccionada
           queda realmente sin stock. No esperamos a que la decision de preorder
           asincrona haya terminado, porque eso dejaba el texto en "Comprar ahora". */
        var stockHub=q(root,'[data-lbx-stock-hub]');
        var fastStock=q(root,'[data-lbx-fast-stock]');
        var outOfStock=!!((stockHub && stockHub.getAttribute('data-lbx-stock-mode')==='out') ||
          (fastStock && fastStock.classList.contains('is-out')));
        return !!(preorder && outOfStock);
      }

      function sync(){
        var sourceTitle=q(root,'.lbx-product-info .lbx-title') || q(root,'.lbx-mobile-hero-heading .lbx-title');
        var sourcePrice=q(root,'[data-lbx-price]') || q(root,'[data-lbx-price-mobile]');
        var sourceCurrent=q(sourcePrice,'[data-lbx-price-current]') || q(sourcePrice,'[data-lbx-price-current-mobile]');
        var sourceCompare=q(sourcePrice,'[data-lbx-price-compare]') || q(sourcePrice,'[data-lbx-price-compare-mobile]');
        var sourceImage=q(root,'[data-lbx-main-image]');
        if(title && sourceTitle) title.textContent=text(sourceTitle);
        if(price && sourceCurrent) price.textContent=text(sourceCurrent);
        var compareText=sourceCompare && !sourceCompare.hidden ? text(sourceCompare) : '';
        if(compare){ compare.textContent=compareText; compare.hidden=!compareText; }
        if(prices) prices.classList.toggle('is-sale',!!compareText);
        if(image && sourceImage){
          var src=sourceImage.currentSrc || sourceImage.getAttribute('src');
          if(src && image.getAttribute('src')!==src) image.setAttribute('src',src);
        }
        var reserve=reserveMode();
        if(action){
          action.disabled=reserve ? false : !!(buy && buy.disabled);
          var actionLabel=action.querySelector('[data-lbx95-sticky-label]');
          if(actionLabel)actionLabel.textContent=(reserve ? 'Reservar' : 'Comprar ahora');
          else if(action.firstChild && action.firstChild.nodeType===3)action.firstChild.nodeValue=(reserve ? 'Reservar ' : 'Comprar ahora ');
        }
      }

      function update(){
        raf=0;
        retireLegacySticky();
        if(!purchase){sticky.classList.remove('is-visible');return;}
        var rect=purchase.getBoundingClientRect();
        var passed=rect.bottom < 8;
        var footerVisible=false;
        if(footer){
          var fr=footer.getBoundingClientRect();
          footerVisible=fr.top < window.innerHeight-12;
        }
        var modalOpen=document.body.classList.contains('lbx78-store-modal-open') ||
          document.body.classList.contains('lbx-preorder-modal-open') ||
          document.body.classList.contains('lbx-wishlist-modal-open');
        /* V99: never show the sticky immediately on first paint. It only becomes
           eligible after the shopper has actually moved down the PDP. */
        var scrolledEnough=(window.scrollY||window.pageYOffset||0)>minimumScroll;
        var show=passed && scrolledEnough && !footerVisible && !modalOpen;
        sticky.classList.toggle('is-visible',show);
        sticky.setAttribute('aria-hidden',show?'false':'true');
      }

      function requestUpdate(){if(!raf)raf=requestAnimationFrame(function(){sync();update();});}

      if(action)action.addEventListener('click',function(){
        if(reserveMode() && preorder){preorder.click();return;}
        if(buy && !buy.disabled)buy.click();
      });
      window.addEventListener('scroll',requestUpdate,{passive:true});
      window.addEventListener('resize',requestUpdate,{passive:true});
      root.addEventListener('change',function(){setTimeout(requestUpdate,20);});
      root.addEventListener('click',function(e){
        if(e.target.closest('[data-lbx-option-button],[data-lbx-thumbnail]'))setTimeout(requestUpdate,50);
      });
      if('MutationObserver' in window){
        var mo=new MutationObserver(requestUpdate);
        mo.observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['src','srcset','hidden','disabled','value']});
      }
      sync();update();
    });
  }

  function cleanDesktopAvailability(){
    /* V95: desktop store availability is intentionally enabled again. The
       product runtime owns visibility using data-lbx-store-eligible. */
    if(!window.matchMedia || !window.matchMedia('(min-width:1025px)').matches)return;
    document.querySelectorAll('[data-lbx-store-stock-panel]').forEach(function(panel){
      var eligible=panel.getAttribute('data-lbx-store-eligible')==='true';
      panel.hidden=!eligible;
      panel.setAttribute('aria-hidden',eligible?'false':'true');
      panel.style.setProperty('display',eligible?'block':'none','important');
    });
  }

  function init(){
    retireLegacySticky();
    initSticky();
    cleanDesktopAvailability();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('load',init,{once:true});
  window.addEventListener('resize',function(){setTimeout(cleanDesktopAvailability,60);},{passive:true});
  document.addEventListener('shopify:section:load',init);

  /* V78 can append its old body-level sticky after DOMContentLoaded. Remove any
     late instance without observing the whole page subtree forever. */
  if('MutationObserver' in window){
    var bodyObserver=new MutationObserver(function(records){
      var found=false;
      records.forEach(function(record){
        record.addedNodes.forEach(function(node){
          if(node.nodeType===1 && (node.matches('.lbx78-sticky-buy') || node.querySelector && node.querySelector('.lbx78-sticky-buy')))found=true;
        });
      });
      if(found)retireLegacySticky();
    });
    function observeBody(){if(document.body)bodyObserver.observe(document.body,{childList:true});}
    if(document.body)observeBody();else document.addEventListener('DOMContentLoaded',observeBody,{once:true});
  }
})();


/* ==== labosch-v88-final.js ==== */
(function(){
  'use strict';
  var modal=document.querySelector('[data-lbx88-contact-modal]');
  if(!modal) return;
  var panel=modal.querySelector('.lbx88-contact-modal__panel');
  var lastTrigger=null;

  function normalizeArea(area){
    area=(area||'comercial').toLowerCase();
    if(area.indexOf('taller')>-1) return 'taller';
    if(area.indexOf('garant')>-1) return 'garantias';
    return 'comercial';
  }
  function setArea(area){
    area=normalizeArea(area);
    var select=modal.querySelector('[data-lbx89-contact-destination]');
    if(select){
      select.value=area;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      return;
    }
    var input=modal.querySelector('[data-lbx88-contact-area-input="'+area+'"]');
    if(input) input.checked=true;
  }
  function openModal(area,trigger){
    lastTrigger=trigger||document.activeElement;
    setArea(area);
    modal.hidden=false;
    document.documentElement.classList.add('lbx88-contact-open');
    requestAnimationFrame(function(){
      if(panel){
        panel.scrollTop=0;
        try{panel.focus({preventScroll:true});}catch(e){panel.focus();}
      }
    });
  }
  function closeModal(){
    modal.hidden=true;
    document.documentElement.classList.remove('lbx88-contact-open');
    if(lastTrigger && document.contains(lastTrigger) && lastTrigger.offsetParent!==null){
      try{lastTrigger.focus({preventScroll:true});}catch(e){}
    }
    lastTrigger=null;
  }

  document.addEventListener('click',function(e){
    var trigger=e.target.closest('[data-lbx88-contact-open],a[href="/pages/contacto"],a[href$="/pages/contacto"]');
    if(trigger){
      e.preventDefault();
      openModal(trigger.getAttribute('data-lbx88-contact-area')||'comercial',trigger);
      return;
    }
    if(!modal.hidden && e.target.closest('[data-lbx88-contact-close]')){
      e.preventDefault();
      closeModal();
    }
  });
  document.addEventListener('keydown',function(e){
    if(!modal.hidden && e.key==='Escape'){
      e.preventDefault();
      closeModal();
    }
  });

  var status=modal.querySelector('[data-lbx88-contact-status]');
  if(status){
    openModal('comercial',null);
  }
})();


/* ==== labosch-v89-final.js ==== */
(function(){
  'use strict';

  function initMenuAccordion(){
    document.querySelectorAll('.lbx84-mobile-menu').forEach(function(nav){
      if(nav.dataset.lbx89Accordion==='1')return;
      nav.dataset.lbx89Accordion='1';
      var details=Array.prototype.slice.call(nav.querySelectorAll(':scope > details'));
      details.forEach(function(item){
        item.addEventListener('toggle',function(){
          if(!item.open)return;
          details.forEach(function(other){if(other!==item && other.open)other.open=false;});
        });
      });
      var drawer=nav.closest('[data-mg2-mobile-drawer]');
      if(drawer && 'MutationObserver' in window){
        var last=drawer.getAttribute('aria-hidden');
        new MutationObserver(function(){
          var now=drawer.getAttribute('aria-hidden');
          if(now===last)return;
          last=now;
          if(now==='false'){
            details.forEach(function(d){d.open=d.classList.contains('lbx84-mobile-menu__group--shop');});
          }
        }).observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
      }
    });
  }

  function initContactDestination(){
    document.querySelectorAll('[data-lbx88-contact-modal]').forEach(function(modal){
      var select=modal.querySelector('[data-lbx89-contact-destination]');
      if(!select || select.dataset.lbx89Ready==='1')return;
      select.dataset.lbx89Ready='1';
      var emailLabel=modal.querySelector('[data-lbx89-contact-email]');
      var emailField=modal.querySelector('[data-lbx89-contact-destination-email]');
      var departmentField=modal.querySelector('[data-lbx89-contact-department]');
      var subjectField=modal.querySelector('[data-lbx89-contact-subject]');
      function sync(){
        var opt=select.options[select.selectedIndex];
        if(!opt)return;
        var email=opt.getAttribute('data-email')||'web@labosch.es';
        var subject=opt.getAttribute('data-subject')||'Consulta comercial LaBosch';
        if(emailLabel)emailLabel.textContent=email;
        if(emailField)emailField.value=email;
        if(departmentField)departmentField.value=opt.textContent.trim();
        if(subjectField)subjectField.value=subject;
      }
      select.addEventListener('change',sync);
      sync();
    });
  }

  function initColorReturnToTop(){
    document.querySelectorAll('.lbx-product-pro').forEach(function(root){
      if(root.dataset.lbx89ColorTop==='1')return;
      root.dataset.lbx89ColorTop='1';
      root.addEventListener('click',function(e){
        if(!window.matchMedia || !window.matchMedia('(max-width:1024px)').matches)return;
        var button=e.target.closest('.lbx-option-block--color [data-lbx-option-button]');
        if(!button || !root.contains(button))return;
        window.setTimeout(function(){
          var y=Math.max(0,root.getBoundingClientRect().top+window.scrollY-6);
          var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({top:y,behavior:reduce?'auto':'smooth'});
        },90);
      },true);
    });
  }

  function initStickyReserve(){
    document.querySelectorAll('[data-lbx87-sticky-atc]').forEach(function(sticky){
      if(sticky.dataset.lbx89Reserve==='1')return;
      sticky.dataset.lbx89Reserve='1';
      var sectionId=sticky.getAttribute('data-lbx87-section');
      var root=document.getElementById('lbx-product-'+sectionId)||document.querySelector('.lbx-product-pro');
      if(!root)return;
      var action=sticky.querySelector('[data-lbx87-sticky-buy]');
      var preorder=root.querySelector('[data-lbx-preorder-open]');
      var preorderRoot=root.querySelector('[data-lbx-preorder-root]');
      var stockHub=root.querySelector('[data-lbx-stock-hub]');
      var fastStock=root.querySelector('[data-lbx-fast-stock]');
      if(!action)return;

      function isOut(){
        return !!((stockHub && stockHub.getAttribute('data-lbx-stock-mode')==='out') || (fastStock && fastStock.classList.contains('is-out')));
      }
      function hasReserveUi(){
        return !!(preorder && preorderRoot && !preorderRoot.hidden && (root.classList.contains('has-lbx-preorder-active')||root.classList.contains('has-lbx-reserve-only')));
      }
      function sync(){
        var reserve=isOut() && !!preorder;
        var label=action.querySelector('[data-lbx95-sticky-label]');
        action.classList.toggle('is-reserve',reserve);
        if(reserve){
          action.disabled=false;
          if(label)label.textContent='Reservar';
        }else{
          if(label)label.textContent='Comprar ahora';
        }
      }
      action.addEventListener('click',function(e){
        if(!isOut())return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if(hasReserveUi()){
          preorder.click();
          return;
        }
        /* The preorder decision can arrive asynchronously; give it one short chance. */
        window.setTimeout(function(){
          if(hasReserveUi())preorder.click();
          else if(preorderRoot && !preorderRoot.hidden)preorderRoot.scrollIntoView({behavior:'smooth',block:'center'});
        },180);
      },true);
      if('MutationObserver' in window){
        new MutationObserver(sync).observe(root,{subtree:true,attributes:true,attributeFilter:['hidden','data-lbx-stock-mode','disabled']});
      }
      sync();
    });
  }

  function init(){
    initMenuAccordion();
    initContactDestination();
    initColorReturnToTop();
    initStickyReserve();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('load',init,{once:true});
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v90-final.js ==== */
(function(){
  'use strict';

  function initContactFeedback(){
    document.querySelectorAll('.lbx88-contact-form').forEach(function(form){
      if(form.dataset.lbx90Submit==='1')return;
      form.dataset.lbx90Submit='1';
      form.addEventListener('submit',function(){
        var button=form.querySelector('[data-lbx90-contact-submit]');
        var text=form.querySelector('[data-lbx90-contact-submit-text]');
        if(button){button.classList.add('is-sending');button.disabled=true;button.setAttribute('aria-busy','true');}
        if(text)text.textContent='Enviando…';
      });
    });
  }

  function initAboutReveal(){
    var root=document.querySelector('[data-lbx90-about]');
    if(!root || root.dataset.lbx90Reveal==='1')return;
    root.dataset.lbx90Reveal='1';
    if(!('IntersectionObserver' in window))return;
    var nodes=root.querySelectorAll('.lbx90-about__manifesto-copy,.lbx90-about__origin-card,.lbx90-about__section-head,.lbx90-about__history-card,.lbx90-about__today-copy,.lbx90-about__value');
    nodes.forEach(function(n){n.classList.add('lbx90-reveal')});
    var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}})},{threshold:.08,rootMargin:'0px 0px -40px 0px'});
    nodes.forEach(function(n){io.observe(n)});
  }

  function init(){initContactFeedback();initAboutReveal();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v91-final.js ==== */
(function(){
  'use strict';
  function initLocale(){
    document.querySelectorAll('[data-lbx91-locale]').forEach(function(root){
      if(root.dataset.lbx91Ready==='1')return;root.dataset.lbx91Ready='1';
      var select=root.querySelector('[data-lbx91-country-select]');
      var name=root.querySelector('[data-lbx91-country-name]');
      var flag=root.querySelector('.lbx91-country-flag');
      if(!select)return;
      select.addEventListener('change',function(){
        var opt=select.options[select.selectedIndex];
        if(name)name.textContent=opt.dataset.countryName||opt.textContent||'';
        if(flag && opt.dataset.flagUrl){flag.innerHTML='';var img=document.createElement('img');img.src=opt.dataset.flagUrl;img.alt='';img.width=24;img.height=18;flag.appendChild(img);}
      });
    });
  }
  function init(){initLocale();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v94-final.js ==== */
(function(){
  'use strict';
  var KEY='lbxComparatorSelection';
  function read(){
    try{var x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x.filter(Boolean).slice(0,2):[]}catch(e){return []}
  }
  function normalize(){
    var items=read();
    try{localStorage.setItem(KEY,JSON.stringify(items))}catch(e){}
    return items;
  }
  function setTrayState(open){
    var tray=document.querySelector('[data-mg2-compare-tray]');
    if(!tray)return;
    var items=normalize();
    if(!items.length){tray.hidden=true;document.body.classList.remove('lbx95-compare-tray-present','lbx95-compare-tray-open');return;}
    tray.hidden=false;
    tray.classList.toggle('is-collapsed',!open);
    document.body.classList.add('lbx95-compare-tray-present');
    document.body.classList.toggle('lbx95-compare-tray-open',!!open);
    var btn=tray.querySelector('[data-mg2-compare-collapse]');
    if(btn)btn.setAttribute('aria-expanded',open?'true':'false');
  }
  function removeTrayOnComparator(){
    if(!document.querySelector('[data-lbx-comparator]'))return false;
    document.querySelectorAll('[data-mg2-compare-tray]').forEach(function(node){node.remove()});
    document.body.classList.remove('lbx95-compare-tray-present','lbx95-compare-tray-open');
    return true;
  }
  function forceFullCompareNavigation(e){
    var link=e.target.closest&&e.target.closest('[data-mg2-compare-go]');
    if(!link || link.classList.contains('is-disabled') || link.getAttribute('aria-disabled')==='true')return;
    e.preventDefault();
    var href=link.href || '/pages/comparador?view=comparador#lbx-comparison';
    if(href.indexOf('#lbx-comparison')<0)href=href.replace(/#.*$/,'')+'#lbx-comparison';
    window.location.assign(href);
  }
  function compareButtonClick(e){
    if(!e.target.closest)return;
    var btn=e.target.closest('[data-mg2-compare-handle]');
    if(!btn)return;
    window.setTimeout(function(){setTrayState(true)},80);
  }
  function init(){
    normalize();
    if(removeTrayOnComparator())return;
    var tray=document.querySelector('[data-mg2-compare-tray]');
    var isHome=document.body && document.body.getAttribute('data-template')==='index';
    if(isHome){
      /* Do not surface an old comparison just because the customer returned
         to the homepage. A fresh compare click on home opens it immediately. */
      if(tray)tray.hidden=true;
      document.body.classList.remove('lbx95-compare-tray-present','lbx95-compare-tray-open');
      return;
    }
    /* Persisted selections stay available but collapsed. A new selection on
       the current page expands the tray immediately. */
    setTrayState(false);
  }
  document.addEventListener('click',forceFullCompareNavigation,true);
  document.addEventListener('click',compareButtonClick,true);
  document.addEventListener('mg2:compare-change',function(){window.setTimeout(function(){setTrayState(true)},0)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();


/* ==== labosch-v95-final.js ==== */
(function(){
  'use strict';

  function isDesktop(){return window.matchMedia && window.matchMedia('(min-width:1025px)').matches;}

  function initHeaderMenus(){
    var locale=document.querySelector('.mg2-topbar [data-lbx91-locale]');
    var help=document.querySelector('[data-lbx95-desktop-help]');
    if(locale && locale.dataset.lbx95Ready!=='1'){
      locale.dataset.lbx95Ready='1';
      locale.addEventListener('toggle',function(){if(locale.open && help)help.open=false;});
    }
    if(help && help.dataset.lbx95Ready!=='1'){
      help.dataset.lbx95Ready='1';
      help.addEventListener('toggle',function(){if(help.open && locale)locale.open=false;});
    }
    if(document.documentElement.dataset.lbx95HeaderOutside!=='1'){
      document.documentElement.dataset.lbx95HeaderOutside='1';
      document.addEventListener('click',function(e){
        if(help && help.open && !help.contains(e.target))help.open=false;
        if(locale && locale.open && !locale.contains(e.target))locale.open=false;
      });
      document.addEventListener('keydown',function(e){
        if(e.key!=='Escape')return;
        if(help)help.open=false;
        if(locale)locale.open=false;
      });
    }
  }

  function restoreDesktopStoreStock(){
    if(!isDesktop())return;
    document.querySelectorAll('[data-lbx-store-stock-panel]').forEach(function(panel){
      var eligible=panel.getAttribute('data-lbx-store-eligible')==='true';
      panel.hidden=!eligible;
      panel.setAttribute('aria-hidden',eligible?'false':'true');
      panel.style.setProperty('display',eligible?'block':'none','important');
    });
  }

  function initStoreStockWatcher(){
    if(!isDesktop())return;
    document.querySelectorAll('.lbx-product-pro').forEach(function(root){
      if(root.dataset.lbx95StoreWatcher==='1')return;
      root.dataset.lbx95StoreWatcher='1';
      var panel=root.querySelector('[data-lbx-store-stock-panel]');
      if(!panel || !('MutationObserver' in window))return;
      var mo=new MutationObserver(function(records){
        var relevant=records.some(function(record){return record.attributeName==='data-lbx-store-eligible';});
        if(relevant)restoreDesktopStoreStock();
      });
      /* Critical V97: never observe hidden/style here. restoreDesktopStoreStock()
         itself writes those attributes; observing them created a self-triggering
         MutationObserver loop that could freeze product pages on desktop. */
      mo.observe(panel,{attributes:true,attributeFilter:['data-lbx-store-eligible']});
    });
  }

  function init(){
    initHeaderMenus();
    restoreDesktopStoreStock();
    initStoreStockWatcher();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('load',init,{once:true});
  window.addEventListener('resize',function(){window.setTimeout(init,80);},{passive:true});
  document.addEventListener('shopify:section:load',init);
})();

